module.exports = __webpack_public_path__ + "img/v-1.8156fab4.svg";